import {fetchHelpPageSuccess} from "modules/actions/help";
import {HelpPages} from "modules/enums";
import {createReducer} from "redux-act";

type IState = Required<ReturnType<typeof fetchHelpPageSuccess>["payload"]>;

const defaultPage: IState[HelpPages] = {
	id: 0,
	type: "",
	title: "",
	text: "",
};

const initialState: IState = {
	[HelpPages.HowToPlay]: defaultPage,
	[HelpPages.Terms]: defaultPage,
	[HelpPages.Prizes]: defaultPage,
	[HelpPages.Mulligan]: defaultPage,
};

export const help = createReducer({}, initialState).on(fetchHelpPageSuccess, (state, payload) => ({
	...state,
	...payload,
}));
